import {validateReferenceInstrumentEvidence} from './referenceInstrumentEvidence.js';
import {parseRecordedManualLength} from './manualLength.js';
import {formatLength} from './units.js';
const edges=['AB','BC','CD','DA','AC'];

/** Validate original recorded spans, independently of later display units or
 * edited room geometry. Native readings never become manual measurements. */
export function validateQuadrilateralLengthEvidence(value,max){
 if(!value||!Number.isFinite(value.metres)||value.metres<.1||value.metres>max)throw Error('A recorded outline distance is missing or outside its supported range.');
 if(Object.hasOwn(value,'sourceEvidence')){
  if(value.lengthSource!=='instrument-recorded'||Object.hasOwn(value,'manualInput'))throw Error('The outline distance has conflicting manual and instrument evidence.');
  validateReferenceInstrumentEvidence(value.sourceEvidence,value.metres);
 }else{
  if(value.lengthSource!=='operator-entered')throw Error('The outline distance has no supported original source.');
  if(value.manualInput!==undefined){
   const raw=value.manualInput;
   const parsed=parseRecordedManualLength(raw,{min:.1,max});
   if(!parsed.ok||Math.abs(parsed.metres-value.metres)>1e-9||parsed.enteredUnit!==raw.enteredUnit||parsed.explicitUnit!==raw.explicitUnit)throw Error('The outline distance differs from its original manual input.');
  }
 }
}

/** Only compare the five original acquisition slots, not the intentional
 * duplicates stored with each wall and its containing room. */
export function assertDistinctQuadrilateralReadings(lengths){
 const seen=new Map();
 for(const [index,length]of lengths.entries()){
  const e=length.sourceEvidence;if(e?.source!=='bluetooth')continue;
  const key=e.readingID.toLowerCase();
  if(seen.has(key))throw Error(`${edges[seen.get(key)]} and ${edges[index]} need separate Huepar readings. Measure each span again.`);
  seen.set(key,index);
 }
}

/** Shared allowlisted display values; caller renders as text/escaped HTML. */
export function quadrilateralEvidenceRows(item,doc){
 if(!item.outlineLengths)return[];
 const rows=[];
 for(const length of item.outlineLengths){
  const edge=length.edge==='AC'?'diagonal A–C':length.edge,e=length.sourceEvidence;
  rows.push([`Recorded ${edge} distance`,formatLength(length.metres,doc,3)],
   [`Original ${edge} source`,e?(e.source==='bluetooth'?e.deviceModel:'LiDAR horizontal estimate'):'Operator-entered']);
  if(length.manualInput){const m=length.manualInput;rows.push([`Original ${edge} entry`,`${m.enteredText} · ${m.explicitUnit?'explicit unit':'recorded Site unit'} ${m.enteredUnit}${m.decimalSeparator===','?' · decimal comma':''}`]);}
  if(!e)continue;
  rows.push([`Original ${edge} capture time`,e.capturedAt]);
  if(e.source==='bluetooth')rows.push([`Original ${edge} tool reference`,e.toolReference],[`Original ${edge} display check`,'Operator confirmed'],[`Original ${edge} reading identity`,e.readingID],[`Original ${edge} packet`,e.packetHex]);
  else rows.push([`Original ${edge} reference`,e.reference]);
 }
 return rows;
}
